import { render, staticRenderFns } from "./clean.vue?vue&type=template&id=997aebf8&scoped=true"
import script from "./clean.vue?vue&type=script&lang=js"
export * from "./clean.vue?vue&type=script&lang=js"
import style0 from "./clean.vue?vue&type=style&index=0&id=997aebf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997aebf8",
  null
  
)

export default component.exports